<header [ngClass]="[
    'sticky top-0 z-[50] flex w-full h-20 transition-all duration-300',
    'bg-white/90 backdrop-blur-md border-b border-brand-border'
  ]">
  <div class="flex flex-grow items-center justify-between gap-4 px-4 py-4 md:px-6 2xl:px-11">

    <!-- Left Side: Mobile Menu Toggle & Search -->
    <div class="flex items-center gap-3 flex-1 min-w-0">
      <!-- Mobile Menu Toggle Button -->
      <button (click)="toggleMobileMenu()"
        class="p-2.5 border border-brand-border bg-white rounded-xl hover:bg-slate-50 hover:border-slate-300 transition-colors lg:hidden shrink-0">
        <i data-feather="menu" class="h-5 w-5 text-brand-body"></i>
      </button>

      <!-- Search -->
      <div class="hidden sm:block w-full max-w-md">
        <div class="relative group">
          <button class="absolute left-3.5 top-1/2 -translate-y-1/2 pointer-events-none">
            <i data-feather="search" class="h-4 w-4 text-slate-400 group-focus-within:text-brand-primary transition-colors"></i>
          </button>
          <input type="text" placeholder="Rechercher..."
            class="w-full bg-slate-100/70 hover:bg-slate-100 focus:bg-white border border-transparent focus:border-brand-primary/40 rounded-xl pl-10 pr-4 py-2.5 text-sm font-medium text-brand-title placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-brand-primary/10 transition-all duration-200 xl:w-125" />
        </div>
      </div>
    </div>

    <!-- Right Side: Actions -->
    <div class="flex items-center gap-3 2xsm:gap-5 shrink-0">
      <ul class="flex items-center gap-2 2xsm:gap-3">

        <!-- Dark Mode Toggle -->
        <li>
          <app-theme-toggle></app-theme-toggle>
        </li>

        <!-- Notification Menu Area -->
        <li class="relative">
          <button
            class="relative flex h-10 w-10 items-center justify-center rounded-xl border border-brand-border bg-white text-brand-body hover:text-brand-primary hover:border-brand-primary/30 hover:bg-brand-primary/5 transition-all duration-200">
            <i data-feather="bell" class="h-5 w-5"></i>
            <span class="absolute top-2 right-2 z-1 flex h-2 w-2 rounded-full bg-red-500 ring-2 ring-white"></span>
          </button>
        </li>
      </ul>

      <!-- User Area -->
      <div class="relative">
        <button class="flex items-center gap-3 profile-trigger group pl-1 pr-2 py-1 -mr-1 rounded-xl hover:bg-slate-50 transition-colors"
          (click)="toggleMenu($event)">
          <div class="hidden text-right lg:block">
            <p class="text-sm font-bold text-brand-title trigger-text transition-colors leading-tight">
              {{ userAuth().firstname }} {{ userAuth().lastname }}
            </p>
            <p class="text-[10px] font-semibold text-brand-body uppercase tracking-wider mt-0.5 opacity-70">
              {{ userAuth().role?.name }}
            </p>
          </div>

          <div
            class="h-10 w-10 rounded-full ring-2 ring-slate-200 group-hover:ring-brand-primary/50 transition-all bg-white overflow-hidden">
            <img [src]="userAuth().avatarPath || '/assets/images/user5.jpg'"
              class="rounded-full h-full w-full object-cover" alt="User" />
          </div>

          <i data-feather="chevron-down"
            class="hidden sm:block h-4 w-4 text-brand-body trigger-chevron transition-transform duration-300"></i>
        </button>

        <!-- Premium Dropdown Menu -->
        <div *ngIf="isOpen"
          class="absolute right-0 mt-3 w-72 origin-top-right rounded-2xl border border-brand-border bg-white shadow-2xl shadow-slate-900/10 animate-dropdown-in overflow-hidden z-[100]">

          <!-- Dropdown Header -->
          <div class="px-5 py-4 bg-gradient-to-b from-slate-50 to-white border-b border-brand-border">
            <div class="flex items-center gap-3">
              <div class="h-11 w-11 rounded-full ring-2 ring-brand-primary/30 p-0.5 bg-white overflow-hidden shrink-0">
                <img [src]="userAuth().avatarPath || '/assets/images/user5.jpg'"
                  class="rounded-full h-full w-full object-cover" alt="User" />
              </div>
              <div class="overflow-hidden">
                <p class="text-sm font-bold text-brand-title truncate">{{ userAuth().firstname }} {{
                  userAuth().lastname }}</p>
                <p class="text-[11px] font-medium text-brand-body truncate opacity-80">{{ userAuth().email ||
                  'Session active' }}</p>
              </div>
            </div>
          </div>

          <!-- Menu Items -->
          <div class="py-1.5">
            <button *ngFor="let item of profileMenu" (click)="item.action()"
              class="w-full flex items-center gap-3 px-5 py-3 text-sm font-medium text-brand-title menu-item-hover transition-all duration-200 group/item">
              <div
                class="flex h-9 w-9 items-center justify-center rounded-lg bg-slate-100 group-hover/item:bg-brand-primary/10 transition-colors">
                <i [attr.data-feather]="item.featherIcon || 'user'" class="h-4 w-4 text-brand-body menu-icon"></i>
              </div>
              <span>{{ item.title }}</span>
            </button>
          </div>

          <!-- Quick Tip / Decorative element -->
          <div class="px-5 py-2.5 bg-brand-primary/5 border-t border-brand-border">
            <p class="text-[10px] font-semibold text-brand-primary uppercase tracking-widest text-center">Version
              Premium</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</header>
